import XLSX from 'xlsx'
import _ from 'lodash'

// adds a 'saveAs' function to the global scope
// it's used by the 'xlsx' package to download files if available
// without it, we rely on 'xlsx' file download implementation
// which is causing an issue where the file is downloaded
// without a proper file name or extension
import 'file-saver'

const parseFile = file => {
  const reader = new window.FileReader()
  return new Promise((resolve, reject) => {
    reader.onload = () => {
      const res = reader.result
      const workbook = XLSX.read(res, { type: 'binary' })
      const worksheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[worksheetName]
      const jsonObject = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false })
      resolve(jsonObject)
    }
    reader.readAsBinaryString(file)
  })
}

const downloadFileWithHeaders = (data, headers, filename) => {
  const worksheet = XLSX.utils.aoa_to_sheet(headers)
  XLSX.utils.sheet_add_aoa(worksheet, data, { origin: -1 })
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
  XLSX.writeFile(workbook, filename, { bookSST: true, type: 'binary' })
}

const downloadJson = (data, filename, colWidths) => {
  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()
  if (colWidths) {
    worksheet['!cols'] = _.map(colWidths, width => {
      return { width }
    })
  }
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
  XLSX.writeFile(workbook, filename, { bookSST: true, type: 'binary' })
}

export default {
  parseFile,
  downloadJson,
  downloadFileWithHeaders
}
